import { render } from "./CreateUser.vue?vue&type=template&id=a9d8e394&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=a9d8e394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d8e394"]])

export default __exports__